/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { createRef, Fragment, KeyboardEvent, useState } from 'react'
import { Form, Input, Popover } from 'antd'
import * as _ from 'lodash'
import uuid from 'uuid'
import { isMobile } from 'react-device-detect'
import { observer } from 'mobx-react'
import { FormComponentProps } from 'antd/lib/form'
import { useOnMount } from '@utils/reactExt'
import { UserItem } from '@store/userStore'
import { PUBLISH_PICK_TYPE, SIDE_MENU } from '@constants/index'
import * as Utils from '@utils/utils'
import useRootStore from '@store/useRootStore'
import { BET_HIT_STATE, MESSAGE_TYPE, PROPERTY_ID } from 'adv-protocol/src/GameCommon'
import { Schema$Pick } from '@v2/protocol/pick'
// icon
import { DiaIco, GmoneyIco } from '@shared/Icon/MoneyIcon'
import DummyImg from '@assets/images/bg/dummy-img.jpg'
import SuccessImg from '@assets/images/icon/betting_history_icon/success.png'
import FailImg from '@assets/images/icon/betting_history_icon/fail.png'
import CancelImg from '@assets/images/icon/betting_history_icon/cancel.png'
// css
import { TxtLimit } from '@styles/base.style'
import { Button, FooterBtnStyle, SpanButton } from '@styles/button.style'
import { SpotsQuickMenuList } from '@styles/modal'
import { AttachedIco } from '@shared/Icon/MessageIcon'
import { ReplyTargetUser } from '@store/messageStore'
import { PickMessageWrap, PickWrap } from '@views/Pick/PickList/index.style'
import { BettingHistoryHeader } from '@views/BettingHistory/BettingHistoryListItem/index.style'
import { FROM_VIEW_TYPE, GlobalStoreKey } from '@v2/constants/common'
import BottomLoading from '@components/BottomLoading'
import { getSportIconElementsAscendingOrderBySportIdAndRemoveDuplicated } from '@utils/jsxutils'
import {
  ImgPreview,
  LinkWrap,
  MessageInputWrap,
  ModalGmoneyStyle,
  PickBtnStyle,
  SharedBetStyle,
} from './index.style'
import PickSelector from './PickSelector'
import GiftSelector from './GiftSelector'
import dayjs from 'dayjs'
import PopupUtils from '@utils/popup-utils'
import DialogUtils from '@utils/dialog-utils'
import { loadOrReload } from '@utils/utils'

const FORM_FIELD_ID = {
  RECVNICK: 'recvNick',
  TITLE: 'title',
  CONTENT: 'content',
  LINK: 'link',
}

// icon
const Gmoney = (
  <GmoneyIco/>
)
export const ModalGmoney = (
  <ModalGmoneyStyle style={{ padding: '5px' }}>
    <GmoneyIco/>
  </ModalGmoneyStyle>
)
// image
const { Search, TextArea } = Input

interface MessageContentProps extends FormComponentProps {
  visible: boolean
  setVisible: (arg: boolean) => void
  receive?: ReplyTargetUser
  action?: string
  messageType?: string
  publishPick?: Schema$Pick
  setPublishPick?: (arg: Schema$Pick) => void
  useRequestWaitTimer?: boolean
  fromViewType: FROM_VIEW_TYPE
}

enum FORM_VALIDATE_STATUS {
  NONE = '',
  ERROR = 'error',
  SUCCESS = 'success',
  WARNING = 'warning',
  VALIDATING = 'validating',
}

export enum MESSAGE_CONTENT_MODE {
  PICK,
  PICK_PUBLISH,
  BETTING_HISTORY_SHARE,
  BETTING_HISTORY_SELECTED,
  USER_ITEM_SELECTED,
}

const MessageContent: React.FC<MessageContentProps> = (props: MessageContentProps) => {
  const {
    setVisible,
    form,
    receive,
    action,
    publishPick,
    setPublishPick,
    useRequestWaitTimer,
    visible,
    fromViewType,
  } = props
  let { messageType } = props
  const {
    authStore,
    messageStore,
    globalStore,
    bettingHistoryStore,
    clubStore,
    matchupStore,
    componentStore,
  } = useRootStore()
  const { userInfo } = authStore
  const { getFieldDecorator } = form
  const [visiblePickList, setVisiblePickList] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [isChangeNick, setIsChangeNick] = useState(false)
  const [recvNickValidateStatus, setRecvNickValidateStatus] = useState<FORM_VALIDATE_STATUS>(FORM_VALIDATE_STATUS.ERROR)
  const [recvNickValidateMessage, setRecvNickValidateMessage] = useState('')
  const [visibleGiftList, setVisibleGiftList] = useState(false)
  const [selectedUserItem, setSelectedUserItem] = useState<UserItem>(null)
  const [selectedUserItemCount, setSelectedUserItemCount] = useState(0)
  const [visiblePopover, setVisiblePopover] = useState(false)
  const [visibleSharedLink, setVisibleSharedLink] = useState(false)
  const [attachUrlValidateMessage, setAttachUrlValidateMessage] = useState('')
  const [attachedImageFile, setAttachedImageFile] = useState(null)
  const [previewAttachedMessageImageURL, setPreviewAttachedMessageImageURL] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const days = ['일', '월', '화', '수', '목', '금', '토']

  const selectedBettingHistory = bettingHistoryStore.selectedBettingHistory[fromViewType]
  const bettingHistoryShareEnabled = _.toString(globalStore.findGlobalSetting(GlobalStoreKey.BETTING_HISTORY_SHARE_ENABLED)?.value ?? 0) === '1'
  const messageImageAttachEnabled = _.toString(globalStore.findGlobalSetting(GlobalStoreKey.MESSAGE_IMAGE_ATTACH_ENABLED)?.value ?? 0) === '1'

  const fileInputComponent = createRef<HTMLInputElement>()

  let messageContentMode
  if (publishPick) {
    messageContentMode = MESSAGE_CONTENT_MODE.PICK_PUBLISH
  } else if (selectedBettingHistory) {
    messageContentMode = MESSAGE_CONTENT_MODE.BETTING_HISTORY_SELECTED
  } else if (selectedUserItem) {
    messageContentMode = MESSAGE_CONTENT_MODE.USER_ITEM_SELECTED
  } else if (bettingHistoryShareEnabled) {
    messageContentMode = MESSAGE_CONTENT_MODE.BETTING_HISTORY_SHARE
  } else if (globalStore.isAvailableMenu(SIDE_MENU.PICK)) {
    messageContentMode = MESSAGE_CONTENT_MODE.PICK
  }

  const isClubMessage = !_.isEmpty(componentStore.extraClubId)
  messageType = isClubMessage ? '쪽지' : '메시지'

  let clubName = ''
  if (isClubMessage) {
    let club
    if (matchupStore.club.id === componentStore.extraClubId) {
      club = matchupStore.club
    } else {
      club = _.find(clubStore.simpleClubs, el => el.id === componentStore.extraClubId)
    }

    if (club) {
      clubName = club.name
    }
  }

  useOnMount(() => {
    stopRequestWaitTimer()
  })

  // TODO 중복되는 코드가 존재하므로 찾아서 개선할 것. - PickSelector.tsx#getDateFormat, MessageListItemFooter.tsx#getDateFormat
  const getDateFormat = (date: string): string => {
    const d = dayjs(date)
    const f = [d.format('MM/DD'), '(', _.nth(days, d.day()), ') ', d.format('HH:mm')]
    return f.join('')
  }

  const resetFormFieldValue = (id: string) => {
    const value = form.getFieldValue(id)
    if (!_.isEmpty(_.trim(value))) {
      form.setFieldsValue({ [id]: '' })
    }
  }

  const reset = () => {
    bettingHistoryStore.resetSelectedBettingHistory(fromViewType)
    bettingHistoryStore.setBettingHistoryInitProps({ onlyMajorClub: false, fromViewType })
    resetFileInputComponent()
    resetPreviewAttachImageUrl()
    resetAttachImage()
    setPublishPick(null)
    setSelectedUserItem(null)
  }

  const resetFileInputComponent = () => {
    if (fileInputComponent.current) {
      fileInputComponent.current.value = ''
    }
  }

  const resetPreviewAttachImageUrl = () => {
    if (_.isEmpty(previewAttachedMessageImageURL)) {
      return
    }

    setPreviewAttachedMessageImageURL(null)
  }

  const resetAttachImage = () => {
    if (_.isNil(attachedImageFile)) {
      return
    }

    setAttachedImageFile(null)
  }

  const isDisabledContent = (): boolean => {
    if (publishPick || selectedBettingHistory) {
      resetFormFieldValue(FORM_FIELD_ID.CONTENT)
      resetPreviewAttachImageUrl()
      resetAttachImage()
      return true
    }

    return false
  }

  const getContentPlaceholdForClubMessage = () => {
    return '내용을 입력해주세요.(2000자 이내)'
  }

  const getContentPlaceholdForCommonMessage = () => {
    return '내용을 입력해주세요.(600자 이내)'
  }

  const getContentPlacehold = () => {
    if (publishPick) {
      return '픽 첨부시 내용을 입력할 수 없습니다.'
    }

    if (selectedBettingHistory) {
      return '베팅내역 첨부시 내용을 입력할 수 없습니다.'
    }

    if (isClubMessage) {
      return getContentPlaceholdForClubMessage()
    }

    return getContentPlaceholdForCommonMessage()
  }

  const validatorCheckNick = value => {
    setRecvNickValidateStatus(FORM_VALIDATE_STATUS.ERROR)

    if (_.isEmpty(_.trim(value))) {
      setRecvNickValidateMessage('받는 사람 닉네임을 입력해주세요.')
      return
    }

    if (value?.length < 2) {
      setRecvNickValidateMessage('닉네임이 너무 짧습니다.')
      return
    }

    setRecvNickValidateMessage('')
    setRecvNickValidateStatus(FORM_VALIDATE_STATUS.SUCCESS)
  }

  const onChangeNick = e => {
    setIsChangeNick(true)
    validatorCheckNick(e.target.value)
  }

  const checkNick = async () => {
    if (isChangeNick) {
      setRecvNickValidateMessage('')
      setRecvNickValidateStatus(FORM_VALIDATE_STATUS.ERROR)

      if (form.getFieldValue(FORM_FIELD_ID.RECVNICK) === userInfo.nick) {
        setRecvNickValidateMessage('본인에게는 메시지를 발송할 수 없습니다.')
        form.validateFields([FORM_FIELD_ID.RECVNICK])
      } else {
        await messageStore.checkNick({ nick: form.getFieldValue(FORM_FIELD_ID.RECVNICK) })
        if (messageStore.receiveUser.check) {
          form.setFieldsValue({ recvNick: '' })
          setIsChangeNick(false)
          form.setFieldsValue({ recvNick: messageStore.receiveUser.nick })
          // Utils.showToast(Utils.TOAST_TYPE.SUCCESS, '유저가 확인되었습니다. 메시지를 보낼수 있습니다.')
          setRecvNickValidateStatus(FORM_VALIDATE_STATUS.SUCCESS)
          setRecvNickValidateMessage('닉네임이 확인이 완료되었습니다.')
          document.getElementById('recvNick').blur()
        } else {
          setRecvNickValidateMessage('존재하지 않는 유저 닉네임 입니다.')
        }
      }
    }
  }

  const sendMessage = async () => {
    if (!visible) {
      return
    }

    // 클럽ID가 있을경우 배터 -> 클럽오즈에게 보내는 메시지임.
    const formData = new FormData()
    formData.append('itemCount', '0')

    if (componentStore.extraClubId) {
      formData.append('clubId', componentStore.extraClubId)
      formData.append('messageType', _.toString(MESSAGE_TYPE.MEMBER_TO_CLUB))
      formData.append('content', form.getFieldValue(FORM_FIELD_ID.CONTENT))
    } else if (messageStore.receiveUser && messageStore.receiveUser.id) { // 일반 메세지 전송
      formData.append('receiverId', messageStore.receiveUser.id)

      if (messageContentMode === MESSAGE_CONTENT_MODE.PICK_PUBLISH) {
        formData.append('messageType', _.toString(MESSAGE_TYPE.PICK_ADD))
        formData.append('content', JSON.stringify({ pickId: publishPick.pickId }))
      } else if (messageContentMode === MESSAGE_CONTENT_MODE.USER_ITEM_SELECTED) {
        formData.append('messageType', _.toString(MESSAGE_TYPE.GIFT))
        formData.append('content', form.getFieldValue(FORM_FIELD_ID.CONTENT)())
        formData.append('itemCode', _.toString(selectedUserItem.item_code))
        formData.append('itemCount', _.toString(selectedUserItemCount))
      } else if (messageContentMode === MESSAGE_CONTENT_MODE.BETTING_HISTORY_SELECTED) {
        formData.append('messageType', _.toString(MESSAGE_TYPE.BETTING_HISTORY_SHARE))
        formData.append('content', JSON.stringify({ betId: bettingHistoryStore.selectedBettingHistory[fromViewType].betId }))
      } else {
        formData.append('messageType', _.toString(MESSAGE_TYPE.NORMAL))
        const content = form.getFieldValue(FORM_FIELD_ID.CONTENT)
        if (!_.isEmpty(_.trim(content))) {
          formData.append('content', content)
        }
      }
    } else if (receive && receive.id) { // 답장
      formData.append('receiverId', receive.id)

      if (componentStore.extraClubId) {
        formData.append('messageType', _.toString(MESSAGE_TYPE.MEMBER_TO_CLUB))
      } else if (!componentStore.extraClubId) {
        if (messageContentMode === MESSAGE_CONTENT_MODE.PICK_PUBLISH) {
          formData.append('messageType', _.toString(MESSAGE_TYPE.PICK_ADD))
          formData.append('content', JSON.stringify({ pickId: publishPick.pickId }))
        } else if (messageContentMode === MESSAGE_CONTENT_MODE.USER_ITEM_SELECTED) {
          formData.append('messageType', _.toString(MESSAGE_TYPE.GIFT))
          formData.append('content', form.getFieldValue(FORM_FIELD_ID.CONTENT))
          formData.append('itemCode', _.toString(selectedUserItem.item_code))
          formData.append('itemCount', _.toString(selectedUserItemCount))
        } else if (messageContentMode === MESSAGE_CONTENT_MODE.BETTING_HISTORY_SELECTED) {
          formData.append('messageType', _.toString(MESSAGE_TYPE.BETTING_HISTORY_SHARE))
          formData.append('content', JSON.stringify({ betId: bettingHistoryStore.selectedBettingHistory[fromViewType].betId }))
        } else {
          formData.append('messageType', _.toString(MESSAGE_TYPE.NORMAL))
          const content = form.getFieldValue(FORM_FIELD_ID.CONTENT)
          if (!_.isEmpty(_.trim(content))) {
            formData.append('content', content)
          }
        }
      }
    }

    if (!componentStore.extraClubId) {
      const attachedURL = form.getFieldValue(FORM_FIELD_ID.LINK)
      if (!_.isEmpty(attachedURL)) {
        formData.append('attachedUrl', attachedURL)
      }

      if (!_.isNil(attachedImageFile)) {
        formData.append('attachedImageFile', attachedImageFile)
      }
    }

    const title = form.getFieldValue(FORM_FIELD_ID.TITLE)
    if (!_.isEmpty(title)) {
      formData.append('title', title)
    }

    try {
      startRequestWaitTimer()
      const errMsg = await messageStore.sendMessage(formData)
      stopRequestWaitTimer()

      if (errMsg.length === 0) {
        Utils.showToast(Utils.TOAST_TYPE.INFO, `${messageType} 보내기를 완료했습니다.`)
        setVisible(false)
        reset()
      } else {
        Utils.showToast(Utils.TOAST_TYPE.INFO, `${errMsg}`)
      }
    } catch (err) {
      stopRequestWaitTimer()
      Utils.showToast(Utils.TOAST_TYPE.INFO, `${messageType} 보내기 실패! 잠시후 다시 시도해 주세요.`)
      console.error(err)
    }
  }

  const startRequestWaitTimer = () => {
    if (!useRequestWaitTimer) {
      return
    }

    setIsLoading(true)

    const seconds = globalStore.findGlobalSetting(GlobalStoreKey.MESSAGE_REQUEST_WAIT_SECONDS)?.value || 30
    const timeOutId = setTimeout(() => {
      stopRequestWaitTimer()
    }, _.toNumber(seconds) * 1000)
    componentStore.setMessageSendingTimeoutId(_.toNumber(timeOutId))
  }

  const stopRequestWaitTimer = () => {
    clearTimeout(componentStore.messageSendingTimeoutId)
    setIsLoading(false)
    componentStore.setMessageSendingTimeoutId(null)
  }

  const onClickSend = () => {
    if (!isChangeNick) {
      const attachUrl = form.getFieldValue(FORM_FIELD_ID.LINK)
      if (messageContentMode === MESSAGE_CONTENT_MODE.PICK_PUBLISH
        || messageContentMode === MESSAGE_CONTENT_MODE.USER_ITEM_SELECTED) {
        if (userInfo.money < 1000) {
          // 더 이상 사용하지 않는 다이얼로그
          globalStore.pushDialogYesNo({
            text: ['G머니가 부족합니다.'],
            className: 'small-size',
            positivePress: '아이템샵 이동',
            negativePress: '닫기',
            callbackPositive: () => {
              setVisible(false)
              globalStore.closeGeneralPopup()
              if (isMobile) {
                loadOrReload('/itemshop')
              } else {
                PopupUtils.showItemShopPopup()
              }
            },
          })
          return
        }
      }
      if (messageContentMode === MESSAGE_CONTENT_MODE.PICK_PUBLISH
        || messageContentMode === MESSAGE_CONTENT_MODE.USER_ITEM_SELECTED) {
        // if (form.getFieldValue('recvNick') && form.getFieldValue('title')) {
        if (form.getFieldValue('recvNick')) {
          // setVisibleChild(true)
          // 더 이상 사용하지 않는 다이얼로그
          globalStore.pushDialogYesNo({
            title: '픽 첨부',
            text: ['픽 첨부 시 1,000G가 소진됩니다.', '메시지를 보내시겠습니까?'],
            className: 'small-size',
            positivePress: '보내기',
            negativePress: '취소',
            callbackPositive: sendMessage,
          })

        }
      } else if (!componentStore.extraClubId && !form.getFieldValue(FORM_FIELD_ID.RECVNICK)) {
        Utils.showToast(Utils.TOAST_TYPE.ERROR, '받는 사람 닉네임을 입력해주세요.')
      } else if (_.isNil(attachedImageFile)
        && (messageContentMode !== MESSAGE_CONTENT_MODE.BETTING_HISTORY_SELECTED
          && !form.getFieldValue(FORM_FIELD_ID.CONTENT))
      ) {
        Utils.showToast(Utils.TOAST_TYPE.ERROR, '내용을 입력해주세요.')
      } else if (form.getFieldError(FORM_FIELD_ID.CONTENT)) {
        Utils.showToast(Utils.TOAST_TYPE.ERROR, '최대 글자 수를 확인해주세요.')
      } else if (!_.isEmpty(attachUrl) && !validateUrl(attachUrl)) {
        Utils.showToast(Utils.TOAST_TYPE.ERROR, '첨부한 링크를 확인해주세요.')
      } else {
        globalStore.setIgnoreVisibleChangeHandler(false)
        sendMessage()
      }
    } else {
      setRecvNickValidateMessage('받는 사람 닉네임을 확인 해주세요.')
      setRecvNickValidateStatus(FORM_VALIDATE_STATUS.ERROR)
    }
  }

  if ((receive && !form.getFieldValue(FORM_FIELD_ID.RECVNICK) && !form.getFieldValue(FORM_FIELD_ID.TITLE))) {
    setDisabled(true)
    if (action === 'send') {
      form.setFieldsValue({ recvNick: receive.nick, title: `${receive.title}` })
    } else {
      form.setFieldsValue({ recvNick: receive.nick, title: `RE : ${receive.title}` })
    }
  }

  let renderSelectedItemNode
  let renderBetSelectedItemNode
  const onClickUnlockButton = () => {
    reset()
  }
  const onClickPickShareButton = () => {
    reset()
    setVisiblePopover(false)
    setVisiblePickList(true)
  }

  let sharedLinkTextBuffer

  const validateUrl = (url: string) => {
    if (_.isEmpty(_.trim(url))) {
      return true
    }

    return Utils.checkUrl(url)
  }

  const validateAttachUrl = (url: string) => {
    let msg = ''

    if (!_.isEmpty(_.trim(url))
      && !validateUrl(url)) {
      msg = '올바른 url 형식이 아닙니다.'
    }

    setAttachUrlValidateMessage(msg)
  }

  const onChangedSharedUrl = (event) => {
    sharedLinkTextBuffer = _.trim(event.target.value)
  }

  const onClickInputUrl = () => {
    validateAttachUrl(sharedLinkTextBuffer)
    form.setFieldsValue({ [FORM_FIELD_ID.LINK]: sharedLinkTextBuffer })
    setVisibleSharedLink(!_.isEmpty(form.getFieldValue(FORM_FIELD_ID.LINK)))
  }

  const onClickAttachUrlButton = () => {
    setVisiblePopover(false)
    sharedLinkTextBuffer = form.getFieldValue(FORM_FIELD_ID.LINK)

    DialogUtils.showMessageLinkAttachDialog({
      value: sharedLinkTextBuffer,
      onChange: onChangedSharedUrl,
      callbackCloseDialog: () => {
        onClickInputUrl()
      }
    })
  }

  const onClickMoveToUrl = () => {
    const url = form.getFieldValue(FORM_FIELD_ID.LINK)

    if (_.isEmpty(url) || !validateUrl(url)) {
      validateAttachUrl(url)
      return
    }

    globalStore.toMoveWebHomePage(url, 'popup')
  }

  const onVisibleChange = (changedVisible) => {
    setVisiblePopover(changedVisible)
    if (!changedVisible) {
      globalStore.setIgnoreVisibleChangeHandler(false)
    }
  }
  const onClickBettingListShareButton = () => {
    reset()
    globalStore.setVisibleBettingListPopup(true, true, false)
    setVisiblePopover(false)
  }
  const setSelectedUserItemToParent = (selectedItem: UserItem, selectedItemCount: number): void => {
    setSelectedUserItem(selectedItem)
    setSelectedUserItemCount(selectedItemCount)
  }

  const onKeyDownNickName = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.keyCode === 13) {
      e.preventDefault()
    }
  }

  const handleFileOnChange = (event) => {
    event.preventDefault()

    const reader = new FileReader()
    const file = event.target.files[0]
    if (Utils.maxImageFileSizeValidate(file)) {
      reader.onload = () => {
        setPreviewAttachedMessageImageURL(reader.result)
        setAttachedImageFile(file)
      }
      reader.readAsDataURL(file)
    }
    setVisiblePopover(false)
    globalStore.setIgnoreVisibleChangeHandler(false)
  }

  const onClickImagePreviewClose = () => {
    setPreviewAttachedMessageImageURL(null)
    setAttachedImageFile(null)
  }

  // const openBettingShareDetailPopup = async () => {
  //   globalStore.toggleBettingShareDetailPopupVisible(true)
  // }


  if (messageContentMode === MESSAGE_CONTENT_MODE.BETTING_HISTORY_SELECTED) {
    const {
      createdAt,
      foldCount,
      betMoney,
      dividend,
      dividendRate,
      betMoneyType,
      hitState,
    } = selectedBettingHistory.bet

    const { folds } = selectedBettingHistory
    const sportIconElements = _.map(getSportIconElementsAscendingOrderBySportIdAndRemoveDuplicated(
      _.map(folds, fold => fold.sportId), matchupStore.feedSupplier), element => (
      <span key={uuid.v4()}>
      {element}
    </span>
    ))

    const finalbetMoney = betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G ? Utils.getRatioTicketMoney(betMoney) : betMoney
    const finaldividend = betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G ? Utils.getRatioTicketMoney(dividend) : dividend

    // const makeElementHitStateCircle = (foldHitState: number[]) => {
    //   const circleClassNames = []
    //   const elCircles = []
    //   for (const state of foldHitState) {
    //     switch (state) {
    //       case BET_HIT_STATE.SUCCESS:
    //         circleClassNames.push('success')
    //         break
    //       case BET_HIT_STATE.CANCEL:
    //         circleClassNames.push('cancel')
    //         break
    //       case BET_HIT_STATE.ONGOING:
    //         circleClassNames.push('ongoing')
    //         break
    //     }
    //   }
    //
    //   let keyIndex = 0
    //   for (const className of circleClassNames) {
    //     keyIndex += 1
    //     const key = `match-state-circle-${className}-${keyIndex}`
    //     elCircles.push(<span key={key} className={`match-state--circle ${className}`}/>)
    //   }
    //
    //   return (<div className="match-state">{elCircles}</div>)
    // }
    //
    // const elOnGoingHitStateCircle = () => {
    //   const foldHitState: number[] = []
    //   for (const key in folds) {
    //     const fold = folds[key]
    //     for (const data of fold.data) {
    //       foldHitState.push(data.hitState)
    //     }
    //   }
    //
    //   return makeElementHitStateCircle(foldHitState)
    // }

    let eleHitState
    switch (hitState) {
      case BET_HIT_STATE.SUCCESS:
        eleHitState = <img src={SuccessImg} alt="적중" className="hit-state-img"/>
        break
      case BET_HIT_STATE.FAIL:
        eleHitState = <img src={FailImg} alt="미적중" className="hit-state-img"/>
        break
      case BET_HIT_STATE.CANCEL:
        eleHitState = <img src={CancelImg} alt="적중 특례" className="hit-state-img"/>
        break
      case BET_HIT_STATE.ONGOING:
        // eleHitState = elOnGoingHitStateCircle()
        eleHitState = <Fragment/>
        break
    }


    renderBetSelectedItemNode = (
      <BettingHistoryHeader css={SharedBetStyle}>
        <div className="top-info">
          {/*<Button className="share-btn" onClick={openBettingShareDetailPopup}>*/}
          {/*  상세*/}
          {/*</Button>*/}
          <Button secondary onClick={onClickUnlockButton} className="message-bet-btn release">
            <div className="x-ico"/>
          </Button>

          {Utils.getBettingTime(createdAt)}
          {/*<span className="bet-date">{Utils.getBettingTime(createdAt)}</span>*/}

          <div className="betting-history-header">
            <div className="my-bet-info">
              {eleHitState}

              <ul className="my-bet-info--list">
                <li className="my-bet-info--list--item money">
                  {Utils.formatNumber(finalbetMoney)}
                  {betMoneyType === PROPERTY_ID.DIA && <DiaIco/>}
                  {(betMoneyType === PROPERTY_ID.MONEY || betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G) &&
                    <GmoneyIco/>}
                </li>
                <li className="my-bet-info--list--item rate">
                  {Number(dividendRate).toFixed(2)}
                </li>
              </ul>
            </div>

            <div className="division-line header"/>

            <ul className="fold-money-list">
              <li className="fold-money-list--item fold">
                {foldCount}

                <div className="sports-ico-wrap">
                  {sportIconElements}
                </div>
              </li>
              <li className="fold-money-list--item final-dividend">
                {betMoneyType === PROPERTY_ID.DIA && '예상적중다이아'}
                {(betMoneyType === PROPERTY_ID.MONEY || betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G) && '예상적중머니'}
                <span className="final-dividend-value">{Utils.formatNumber(finaldividend)}</span>
                {betMoneyType === PROPERTY_ID.DIA && <DiaIco/>}
                {(betMoneyType === PROPERTY_ID.MONEY || betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G) && <GmoneyIco/>}
              </li>
            </ul>
          </div>
        </div>
      </BettingHistoryHeader>
    )
  } else if (messageContentMode === MESSAGE_CONTENT_MODE.PICK_PUBLISH) {
    const priceMoney = Utils.getPickPublishMoney(publishPick.publishMoneyType, publishPick.priceMoney)

    // ********************* 픽 공유 *********************
    renderSelectedItemNode = (
      <PickMessageWrap className="modal">
        <Button secondary onClick={onClickUnlockButton} className="message-pick-btn release">
          <div className="x-ico"/>
        </Button>

        {getDateFormat(publishPick.dateBettingEnd)}
        {/*<span className="bet-date">{getDateFormat(publishPick.dateBettingEnd)}</span>*/}

        <h3 className="pick-list-tit">{publishPick.title}</h3>

        <div className={isMobile ? 'pick-list' : 'pick-list pc-pick-list'}>
          <span className="pickster-info">
            <img key="dummy" src={DummyImg} alt="프로필" className="pickster-img"/>
            <div className="pickster">
              <div className="pickster--name">{publishPick.picksterName}</div>
              <span className="pickster--hit-rate">
                적중률
              </span>
              <span className="pickster--percent">{`${publishPick.userHitRatioTotal}%`}</span>
            </div>
          </span>

          <ul className="pick-info">
            <li className="pick-info-item">
              <span className="txt">폴드</span>
              <span className="num">{publishPick.foldCount}</span>
            </li>
            <li className="pick-info-item">
              <span className="txt">배당</span>
              <span className="num point">{publishPick.dividendRate}</span>
            </li>
            <li className="pick-info-item price">
              <span className="txt">판매가</span>
              <span className="money-wrap">
                <span className="money-wrap--money" css={TxtLimit}>{Utils.formatNumber(priceMoney)}</span>
                {publishPick.publishMoneyType === PUBLISH_PICK_TYPE.HEART ? Gmoney : '개'}
              </span>
            </li>
          </ul>
        </div>
      </PickMessageWrap>
    )
  } else if (messageContentMode === MESSAGE_CONTENT_MODE.USER_ITEM_SELECTED) {
    renderSelectedItemNode = (
      <PickWrap className="modal">
        <Button css={PickBtnStyle} onClick={onClickUnlockButton}>
          해제333
        </Button>

        {/* <h3 className="pick-list-tit">{selectedUserItem.name}</h3> */}

        <div className="item-list">
          <span className="item-list--item">
            <img alt="ICON" src={selectedUserItem.icon_m} className="item-list--item--img"/>
          </span>

          <span className="item-list--item-quantity">
            <span className="item-list--item-quantity--txt">x</span>
            <span className="item-list--item-quantity--num">{Utils.formatNumber(selectedUserItemCount)}</span>
          </span>
        </div>
      </PickWrap>
    )
  } else if (messageContentMode === MESSAGE_CONTENT_MODE.PICK) {
    // const PICK_TYPE_ELEMENT = [
    //   undefined,
    //   <PickType css={StandbyStyle}>대기</PickType>,
    //   <PickType css={HitStyle}>적중</PickType>,
    //   <PickType css={MissStyle}>미적중</PickType>,
    //   <PickType css={SpecialCaseStyle}>적중특례</PickType>,
    // ]

    renderSelectedItemNode = (
      <Fragment/>
    )
  } else {
    renderBetSelectedItemNode = (
      <Fragment/>
    )
  }

  const attachedList = (
    <SpotsQuickMenuList className="message-quick-list">
      <ul className="quick-menu-list">
        {globalStore.isAvailableMenu(SIDE_MENU.PICK) && !isClubMessage &&
          <li className="quick-menu-list--item">
            <Button
              className="quick-btn"

              onClick={onClickPickShareButton}
            >
              픽 첨부
            </Button>
          </li>
        }
        {bettingHistoryShareEnabled && !isClubMessage &&
          <li className="quick-menu-list--item">
            <Button
              className="quick-btn"
              onClick={onClickBettingListShareButton}
            >
              베팅 내역 공유
            </Button>
          </li>
        }
        {messageImageAttachEnabled && !isClubMessage &&
          <li className="quick-menu-list--item">
            <Button
              className="quick-btn"
              onClick={() => {
                globalStore.setIgnoreVisibleChangeHandler(true)
                reset()
              }}
            >
              이미지
              <input type="file"
                     ref={fileInputComponent}
                     accept="image/jpg,image/jpeg,image/png,image/gif,image/bmp,image/tif,image/tiff"
                     name="profile_img"
                     className="quick-btn--input"
                     onChange={handleFileOnChange}/>
            </Button>
          </li>
        }
        <li className="quick-menu-list--item">
          <Button
            className="quick-btn"
            onClick={onClickAttachUrlButton}
          >
            링크
          </Button>
        </li>
      </ul>
    </SpotsQuickMenuList>
  )

  return (
    <Fragment>
      <MessageInputWrap className="message">
        <Form>
          {isClubMessage ? (
            <h3 className="receive-club">
              받는 클럽<span className="nickname">{clubName}</span>
            </h3>
          ) : (
            <Form.Item
              validateStatus={recvNickValidateStatus}
              help={recvNickValidateMessage}
            >
              {getFieldDecorator('recvNick', {})(
                <Search
                  className="nick-input"
                  placeholder="받는 사람 닉네임을 입력해주세요."
                  disabled={disabled}
                  enterButton="닉네임 확인"
                  onSearch={checkNick}
                  onChange={onChangeNick}
                  onKeyDown={onKeyDownNickName}
                />,
              )}
              <span className="line"/>
            </Form.Item>
          )}

          <div id="messageContentsBox" className="message-contents-box">

            {(isClubMessage) ? (
              <Form.Item>
                {getFieldDecorator(FORM_FIELD_ID.CONTENT, {
                  rules: [{ max: 2000, message: '2000자 이내로 적어주세요.' }],
                })(
                  <TextArea
                    disabled={isDisabledContent()}
                    maxLength={2000}
                    placeholder={getContentPlacehold()}
                    className="contents text-input"
                  />,
                )}
              </Form.Item>) : (
              <Form.Item>
                {getFieldDecorator(FORM_FIELD_ID.CONTENT, {
                  rules: [{ max: 600, message: '600자 이내로 적어주세요.' }],
                })(
                  <TextArea
                    disabled={isDisabledContent()}
                    maxLength={600}
                    placeholder={getContentPlacehold()}
                    className="contents text-input"
                  />,
                )}
              </Form.Item>
            )}

            {previewAttachedMessageImageURL &&
              <ImgPreview>
                <img className="upload-img-preview lhn8" src={previewAttachedMessageImageURL} alt="이미지 미리보기"/>
                <Button className="delete-img-btn" onClick={onClickImagePreviewClose}><span className="x-ico"/></Button>
              </ImgPreview>
            }

            {/*{*/}
            {visibleSharedLink && (
              <Form.Item className="shared link url" validateStatus="error" help={attachUrlValidateMessage}>
                {getFieldDecorator(
                  FORM_FIELD_ID.LINK, {},
                )(
                  <LinkWrap>
                    <SpanButton onClick={onClickMoveToUrl}
                                className="attached-link">{form.getFieldValue(FORM_FIELD_ID.LINK)}</SpanButton>
                  </LinkWrap>
                )}
              </Form.Item>
            )}

            {
              !isClubMessage && (
                <Popover
                  visible={visiblePopover}
                  onVisibleChange={onVisibleChange}
                  placement="bottomRight"
                  content={attachedList}
                  trigger="click"
                  overlayClassName="betting-history-quick-menu"
                  getPopupContainer={() => document.getElementById('messageContentsBox')}
                >
                  <Button className="attached-btn">
                    <AttachedIco/>
                  </Button>
                </Popover>
              )
            }

            {globalStore.isAvailableMenu(SIDE_MENU.PICK) && (componentStore.extraClubId ? null :
              <Fragment>{renderSelectedItemNode}</Fragment>)}
            {bettingHistoryShareEnabled && !componentStore.extraClubId && (
              <Fragment>{renderBetSelectedItemNode}</Fragment>)}
          </div>
        </Form>

        {/*{globalStore.isAvailableMenu(SIDE_MENU.PICK) && (globalStore.selectedClubId ? null : <ModalTxt>첨부 시 1,000{ModalGmoney}가 소진됩니다.</ModalTxt>)}*/}
        {/*{bettingHistoryShareEnable && !globalStore.selectedClubId && (<Fragment>{renderBetSelectedItemNode}</Fragment>)}*/}

        {!isLoading && (<Button secondary css={FooterBtnStyle} onClick={onClickSend} className="one-btn dark">
          보내기
        </Button>)}
        {isLoading && (<Button secondary css={FooterBtnStyle} className="one-btn dark loading-btn">
          <BottomLoading/>
        </Button>)}
      </MessageInputWrap>
      {/* 더이상 사용하지 않는 풀팝업 */}
      <PickSelector visible={visiblePickList} setVisible={setVisiblePickList} setPick={(pick) => {
        setPublishPick(pick)
        form.resetFields([FORM_FIELD_ID.CONTENT])
      }}/>
      {/* 더이상 사용하지 않는 풀팝업 */}
      <GiftSelector
        visible={visibleGiftList}
        setVisible={setVisibleGiftList}
        setSelectedUserItemToParent={setSelectedUserItemToParent}/>
    </Fragment>
  )
}
// export default observer(MessageContent)
export default Form.create<MessageContentProps>()(observer(MessageContent))
